export default __webpack_public_path__ + "static/index-title-versions-en-0d2aa1b4158e27d8338583ab34a06318.png";